// extracted by mini-css-extract-plugin
export default {"wrapper":"RequestsMessageField_wrapper__ph4av","textarea":"RequestsMessageField_textarea__dt-Q2","error":"RequestsMessageField_error__p1eUd"};